var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-label-wrapper"},[_vm._t("default"),_vm._v(" "),(_vm.productHasCustomLabel(_vm.product) && _vm.labelStyle)?_c('div',{staticClass:"label-short label-text",class:[{'ribbon' : _vm.labelStyle && _vm.labelStyle.type === 'ribbon',
							'bow': _vm.labelStyle && _vm.labelStyle.type === 'bow',
							'bow-left': _vm.labelStyle && _vm.labelStyle.position.horizontally === 'left',
							'bow-right': _vm.labelStyle && _vm.labelStyle.position.horizontally === 'right'},
							_vm.getUniqueId(_vm.product.id)],domProps:{"innerHTML":_vm._s(_vm.sanitizedContent)}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }